import { Store } from '@reduxjs/toolkit';
import { ReducersInjectorWithState, StoreType } from '@wajeez-web/stores/base';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { RolesState } from './roles/types';
import rolesReducer from './roles/slices';
import { TeamState } from './wajeezTeam/types';
import wajeezTeamReducer from './wajeezTeam/slices';
export let rolesStore: StoreType<{
  roles: RolesState;
  wajeezTeam: TeamState;
}>;

// export type StoreType = typeof store;
export type RolesDispatch = typeof rolesStore.dispatch;
export type RolesStoreState = ReturnType<typeof rolesStore.getState>;
export const useRolesDispatch = () => useDispatch<RolesDispatch>();
export const useRolesSelector: TypedUseSelectorHook<RolesStoreState> =
  useSelector;
export const getRolesState = (store: Store) =>
  store.getState() as RolesStoreState;

export const injectRolesReducers: ReducersInjectorWithState<
  RolesStoreState
> = () => {
  return [
    {
      name: 'roles',
      reducer: rolesReducer,
    },
    {
      name: 'wajeezTeam',
      reducer: wajeezTeamReducer,
    },
  ];
};
